import { ShareImageDialog } from "@/components/BadgeShare";
import { renderScratchWinImage } from "@/lib/scratchWinImage";
import { imgSrc } from "@/lib/api";

export function ScratchWinShare({ prize, user, onClose }) {
  const u = { ...user, picture: user.picture ? imgSrc(user.picture) : null };
  const link = `${window.location.origin}/registrieren?ref=${user.referral_code}`;
  return (
    <ShareImageDialog prefix="scratch" title="Gewinn teilen" alt={`+${prize} Punkte beim Rubbellos`} fileBase={`itzcouple-rubbellos-${prize}`} onClose={onClose}
      description="Teile deinen Rubbellos-Gewinn als Bild in deiner Instagram- oder TikTok-Story. Dein Einladungscode ist mit drauf."
      msg={`Ich habe gerade ${prize} Punkte beim Rubbellos in der itzPlay Community gewonnen! 🎟️🤩 Mach mit: ${link}`}
      render={(format) => renderScratchWinImage({ prize, user: u, format })} deps={[prize, user.user_id]} />
  );
}
